<script setup lang="ts">
type IsCollapsed = {
  [key: string]: boolean;
}
import type { ServiceCategory, Service } from '~/models/services';
import { useUserFetch } from '~/composables/useUserApi';
const { data: serviceCategories, refresh, pending } = await useUserFetch<ServiceCategory[]>('/api/servicecategories');
const collapsed = useState<IsCollapsed>('servicescollapsed', () => {
  console.log('from serviceecee');
  if (!serviceCategories.value) {
    return {};
  }
  return serviceCategories.value.reduce((acc, category) => {
    acc[category.id] = false;
    return acc;
  }, {} as IsCollapsed);
});
</script>
<template>
  <div class="p-4 mainColor container mx-auto max-w-screen-lg">
    <SectionHeader header="Tjenester & priser">
      Her finner du alle våre tjenester og priser.
      <p class="p-4">Se mer info hos <a class="underline" href="https://www.helsenorge.no/betaling-for-helsetjenester/betaling-hos-lege/">Helse Norge</a></p>
    </SectionHeader>


    <div class="flex flex-col gap-6">
      <div v-for="serviceCategory in serviceCategories" :key="serviceCategory.id"
        class="rounded-lg shadow-md border-1 border-[#dfdfdf]">
        <h2
          class="secondaryColorBackground text-lg font-bold rounded-tl-lg rounded-tr-lg decoration-solid mb-2 p-4 mainColor border-b-1 border-[#dfdfdf] "
          @click="collapsed[serviceCategory.id] = !collapsed[serviceCategory.id]">{{ serviceCategory.name }}</h2>
        <div v-for="service in serviceCategory.services" :key="service.id" v-if="!collapsed[serviceCategory.id]"
          class="flex p-4 gap-2 border-b-1 border-slate-300 hover:border-slate-400 hover:border-l-4">
          <div class="flex-grow">{{ service.name }}</div>
          <div class="flex">{{ service.price }}</div>
        </div>
      </div>
    </div>
    

  </div>
</template>
